import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult, STALE_TIME } from "../common/queries";
import api from "../http-common";

export const attendanceApi = {
	...createCrudHooks({
		baseKey: "attendances",
		basePath: "/attendances",
	}),

	useGetByDate(date) {
		const qc = useQueryClient();
		return useQuery({
			queryKey: ["attendances", date],
			queryFn: () => api.get(`/attendances/byDate/${date}`).then(r => processResult(qc, r)),
			staleTime: STALE_TIME,
		});
	},

	useSet() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ studentId, date, status }) => {
				api.post(`/attendances/${studentId}/${date}/${status}`)
				.then(r => {
					qc.invalidateQueries(['attendances', date]);
					return r;
				})
				.then(r => processResult(qc, r))
			},
		});
	},
};
